// import {
//   isInMiniProgram
// } from "./getMethodFromApp";
import querySting from "query-string";
export function isAndroid() {
  let u = navigator.userAgent;
  let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
  return isAndroid;
}
export function isInMiniProgram() {
  return window.__wxjs_environment === "miniprogram";
}

export function isIos() {
  let u = navigator.userAgent;
  let isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  return isIos;
}
export function saveUserInfoWx() {
  if (isInMiniProgram()) {
    let query = querySting.parse(window.location.search);
    window.wxUserInfo = query;
  }
}

//跳转个人中心
export function jumpPersonal() {
  if (isAndroid()) {
    return window.Android.gotoPersonCenter();
  } else {
    return window.webkit.messageHandlers.gotoAccount.postMessage(0);
  }
}

//返回原生页面
export function goBacks() {
  if (isAndroid() && window?.Android?.goBack) {
    return window.Android.goBack();
  } else if (window?.webkit?.messageHandlers?.goBack) {
    return window.webkit.messageHandlers.goBack?.postMessage(0);
  } else {
    window.history.back();
  }
}

export function goBackFun() {
  if (window.Android?.goBack) {
    window.Android.goBack();
  } else if (window.webkit?.messageHandlers) {
    return window.webkit?.messageHandlers?.goBack?.postMessage(0);
  } else {
    window.history.back();
  }
}

//跳往登录界面
export function goLogin() {
  if (isAndroid()) {
    return window.Android.gotoLogin();
  } else if (isIos() && window?.webkit?.messageHandlers?.gotoLogin?.postMessage) {
    return window.webkit.messageHandlers.gotoLogin.postMessage(0);
  } else {
    return ""
  }
}

//下载文件
export function downLoad(type = "1") {
  if (isAndroid()) {
    if (type === 1) {
      return window.Android.downClaims();
    } else {
      return window.Android.downClaims2();
    }
  } else {
    return window.webkit.messageHandlers.downloadTemplateFile.postMessage(type);
  }
}

//开启/禁用手势返回上一页(type===0关，type===1开)
export function gesture(type) {
  if (isAndroid()) {
    if (type === 0) {
      return window.Android?.backUnable();
    } else {
      return window.Android?.backAble();
    }
  } else if (isIos()) {
    return window.webkit.messageHandlers.backGestureEnable.postMessage(type);
  }
}


// 跳转到首页
export function toIndex(arg) {
  //true首页 false个人中心
  if (isAndroid()) {
    return window.Android.electronicSign(arg);
  } else {
    return window.webkit.messageHandlers.electronicSign.postMessage(arg);
  }
}

//查询安卓状态栏高度
export function getStatusBarHeight() {
  if (isAndroid() && window.Android && window.Android.getStatusBarHeight) {
    return window.Android.getStatusBarHeight() / window.devicePixelRatio;
  } else if (isIos()) {
    return 'env(safe-area-inset-top)';
  } else {
    return 0
  }
}

// 显示标题栏
export function showTitle(title) {
  if (isAndroid() && window?.Android && window?.Android?.showTitle) {
    return window.Android.showTitle(title)
  } else if (isIos() && window?.webkit?.messageHandlers?.showTitle?.postMessage) {
    return window.webkit.messageHandlers.showTitle.postMessage(title);
  } else {
    return ''
  }
}

// 隐藏标题栏
export function hideTitle() {
  if (isAndroid() && window.Android?.hideTitle) {
    return window.Android.hideTitle()
  } else if (isIos() && window?.webkit?.messageHandlers?.hideTitle?.postMessage) {
    return window.webkit.messageHandlers.hideTitle.postMessage(0)
  } else {
    return ''
  }
}


// //获取用户信息
export async function getUserInfoFromApp() {
  if (localStorage.getItem('source') == '3')
    return {
      userCode: localStorage.getItem('userCode'),
      mobile: localStorage.getItem('mobile'),
    };
  if (isAndroid() && window?.Android?.getInfoNewVersion) {
    const info = window.Android.getInfoNewVersion();
    // window.userInfo=JSON.parse(info);
    return JSON.parse(info);
  } else if (isIos() && window?.webkit?.messageHandlers?.getInfo?.postMessage) {
    // window.userInfo=null;
    const v = new Promise(function (res) {
      window.getUserInfo = (item) => {
        // location.reload();
        window.userInfo = JSON.parse(item);
        res(JSON.parse(item))
        //window.userInfo = {userCode,mobile};
      }
    })

    window.webkit.messageHandlers.getInfo.postMessage(0);
    // const data=await v;
    // window.userInfo=data;
    return await v;
    // if(window?.userInfo?.userCode){
    //   return `{"userCode":${window.userInfo.userCode}}`;
    // }else{
    //   return `{"userCode":""}`;
    // }
  } else {
    window.userInfo = {
      userCode: ""
    };
    return {
      userCode: "38916"
    };
  }
}
//安卓获取用户信息
export async function getAndroidUserInfoFromApp() {
  const info = window.Android.getInfoNewVersion();
  return JSON.parse(info);
}
//查询app版本
export async function getCurrentVersionCode() {
  if (isAndroid() && window.Android && window.Android.getCurrentVersionCode) {
    return window.Android.getCurrentVersionCode();
  } else if (window?.webkit?.messageHandlers?.getIOSVersion) {
    const v = new Promise(function (res) {
      window.getVersion = (item) => {
        res(item);
      }
    })
    window.webkit.messageHandlers.getIOSVersion.postMessage(0);
    return await v;
  } else {
    return 0;
  }
}

//跳转到原生页面
export function navigate(pageNum) {
  if (window.Android?.returnModu) {
    window.Android.returnModu(pageNum);
  } else if (window.webkit?.messageHandlers?.returnModu) {
    window.webkit.messageHandlers.returnModu.postMessage(pageNum);
  }
}


// //获取用户信息
export function goToAddressList() {
  if (isAndroid() && window?.Android?.goToAddressList) {
    const info = window.Android.goToAddressList();

    window.callBackAddress = null;
    const v = new Promise(function (res) {
      window.callBackAddress = (item) => {
        window.userInfo = JSON.parse(item);
        res(JSON.parse(item))
      }
    })

    return v;
  } else if (isIos() && window?.webkit?.messageHandlers?.goToAddressList?.postMessage) {
    const v = new Promise(function (res) {
      window.callBackAddress = (item) => {
        window.userInfo = JSON.parse(item);
        res(JSON.parse(item))
      }
    })
    window.webkit.messageHandlers.goToAddressList.postMessage(0);
    return v;
  }
}
export async function getToken() {
  if (localStorage.getItem('source') == 3) {
    return localStorage.getItem('token')
  }

  if (isAndroid() && window.Android && window.Android?.getToken) {
    return window.Android.getToken();
  } else if (isIos() && window?.webkit?.messageHandlers?.getPrepareToken) {
    const v = new Promise(function (res) {
      window.getToken = (item) => {
        res(item);
      };
    });
    window.webkit.messageHandlers.getPrepareToken.postMessage(0);
    return await v;
  } else {
    return '';
  }
}